import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
	FreudButtonModule,
	FreudCardModule,
	FreudPanelMenuModule,
} from '@freud-ds/web-components';

import { ExperimentControlsWidgetComponent } from './experiment-controls-widget.component';

@NgModule({
	declarations: [ExperimentControlsWidgetComponent],
	imports: [
		CommonModule,
		FreudCardModule,
		FreudPanelMenuModule,
		FreudButtonModule,
	],
	exports: [ExperimentControlsWidgetComponent],
})
export class ExperimentControlsWidgetModule {}
